import request from "@/utils/request";

export function list(params) {
  return request({
    url: "/omp/coupon/list",
    method: "GET",
    params,
  });
}
